/**
 * Fait : le contrat PUBLIC du budget — la demande qui pose un plafond, en
 *   CENTIMES entiers, arbitrée par version. Le formulaire d'administration
 *   du client et la route de l'API valident avec le MÊME schéma.
 *
 * Ne fait pas : il ne décrit pas les documents en base ni leurs compteurs
 *   (`donnees/economie.ts`), ne réserve rien, et ne décide pas qui pose les
 *   plafonds : `family_admin`, dit la fonction d'autorisation.
 */

import { z } from 'zod';

/**
 * Poser un plafond. ZÉRO ferme la porte — et le plafond global à zéro
 * bloque TOUTES les voies, abonnement compris (critère 25). La version
 * porte l'arbitrage : sur un budget encore jamais posé, elle vaut 0.
 */
export const demandeDePlafond = z
  .object({
    plafondCentimes: z.number().int().min(0),
    version: z.number().int().min(0),
  })
  .strict();

export type DemandeDePlafond = z.infer<typeof demandeDePlafond>;
